import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import FinancePage from "./Finance/FinancePage";
import Rejection from "../../../Components/Details.jsx/Rejection";
import Agreement from "./Finance/Agreement/Agreement";

export default function FinanceTab(state) {
  const currentTab = "FINANCE";
  const [isEditable, setIsEditable] = useState(false);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [showApproval, setshowApproval] = useState(true);
  const department = state?.locationData?.department?.trim();
  const activeTab = department?.toUpperCase() === currentTab?.toUpperCase();


  return (
    <Grid>
      {activeTab &&
        state?.activeTab === 1 &&
        state?.locationData?.rejectedReason && (
          <Rejection
            locationData={state}
            setIsEditable={setIsEditable}
            isEditable={isEditable}
            setIsReadOnly={setIsReadOnly}
            setshowApproval={setshowApproval}
          />
        )}
      <Grid>
        <Box
          border={!state.isEditable ? "1px solid lightgrey" : "none"}
          borderRadius={2}>
          {/* <FinancePage hospitalId={state.id} isEditable={isEditable} /> */}
          <Agreement
            hospitalId={state.id}
            isReadOnly={isReadOnly}
            setIsReadOnly={setIsReadOnly}
            showApproval={showApproval}
            setshowApproval={setshowApproval}
          />
        </Box>
      </Grid>
    </Grid>
  );
}
